import styles from '@components/components/CmsComponents/components/CmsContactForm/components/Step2/Step2.module.scss';
import React from 'react';
import {
  Button,
  Content,
  FontAwesomeProIcon,
  Heading,
  Link,
  List,
  ListItem,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';

const Step2 = ({ contact, headingLevel = 2 }) => (
  <>
    {contact?.successHeading && (
      <Heading as={getHeadingTag(headingLevel)} size="h7">
        {contact?.successHeading}
      </Heading>
    )}
    {contact?.successTextSmall && (
      <List
        align="center"
        className={styles.list}
        icon={
          <FontAwesomeProIcon icon="check" role="presentation" type="regular" />
        }
        type="checkmark"
      >
        <ListItem className={styles.listItem} data-purpose="success-message">
          {contact?.successTextSmall}
        </ListItem>
      </List>
    )}
    {contact?.successTextLong && <Content>{contact?.successTextLong}</Content>}
    {contact?.backLink?.url && (
      <Button
        render={
          <Link
            target={contact?.backLink?.target}
            to={contact?.backLink?.url}
          />
        }
        variant="link"
      >
        {contact?.backLink?.title}
      </Button>
    )}
  </>
);

export default Step2;
